import { requestFromServer } from "./api-client";

const UserClient = {
  getAllManageable: async (types, page = 1, searchString ) => {
    const itemsPerPage = 10;
    return requestFromServer(
      `v1/Users/list/${page}/${itemsPerPage}?types=${types.join(',')}&search=${searchString}`,
    );
  },
  getSingleUser: async (userId) => {
    return requestFromServer(`v1/Users/get/${userId}`);
  },
  activateUser: async (toggle, userId) => {
    const _body = {
      id: userId,
      active: toggle,
    };
    return requestFromServer("v1/Users/activate", "PUT", JSON.stringify(_body));
  },
  createUser: async (
    email,
    contactEmail,
    type,
    firstName,
    surName,
    userSubType,
    driverLicense,
    driverLicenseExpiration,
    bpNumber,
    tollNumber,
    phone,
  ) => {
    const _body = {
      email,
      contactEmail,
      userType: type,
      firstName,
      surName: surName || "",
      userSubType,
      driverLicense,
      driverLicenseExpiration: driverLicenseExpiration.replace(/\//g, '-'),
      bpNumber,
      tollNumber,
      phone,
    };
    return requestFromServer("v1/Users/create", "POST", JSON.stringify(_body));
  },

  setUserData: async (id, contactEmail, phone ) => {
    const _body = {
      id,
      contactEmail,
      phone,
    };
    return requestFromServer("v1/Users/update", "POST", JSON.stringify(_body));
  },

  setManagerPermissions: async (idUser, selectedId, type) => {
    const _body = {
      idUser,
      TransportersIds: selectedId,
    };
    return requestFromServer(
      `v1/Users/createRelationUserAndTransporters/${type}`,
      "POST",
      JSON.stringify(_body),
    );
  },
  setTransporterPermissions: async (idUser, transportersIds) => {
    const _body = {
      idUser,
      TransportersIds: transportersIds,
    };
    return requestFromServer(
      "v1/Users/createRelationUserAndTransporters",
      "POST",
      JSON.stringify(_body),
    );
  },
  getTransportersByUser: async (idUser) => {
    return requestFromServer(`v1/Users/getTransporters/${idUser}`);
  },
};

export default UserClient;
